import { Action } from 'redux'
import { isType } from 'ts-action'
import { INetOptionReducer } from '@network/models/net-option.model'
import { GetNetOptions, NetOptionsFetching } from './actions'

const initialState: INetOptionReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const netOptionsReducer = (
  state = initialState,
  action: Action,
): INetOptionReducer => {
  if (isType(action, GetNetOptions)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, NetOptionsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
